import { ResponseElement } from '@swagger-api/apidom-ns-openapi-3-0';

/**
 * @public
 */
class Response extends ResponseElement {}
export default Response;